// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"e843a62b","175":"b4c92a8a","215":"f030993b","320":"f2708207","405":"c7fa47e0","496":"ab7ba3ae","621":"1dbb5921","653":"153742fb","775":"7f2e8acd","888":"8c823957","937":"ef3b3ddd"}[chunkId] + ".chunk.js";
};